document.documentElement.classList.remove('no-js');

const qs = (selector, root = document) => root.querySelector(selector);
const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

function lockPage(locked) {
  document.body.classList.toggle('is-locked', locked);
}

qsa('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
  const menu = qs('[data-mobile-menu]');
  const willOpen = menu.hasAttribute('hidden');
  menu.toggleAttribute('hidden', !willOpen);
  qsa('[data-menu-toggle]').forEach((item) => item.setAttribute('aria-expanded', String(willOpen)));
  lockPage(willOpen);
}));

function openCart() {
  const drawer = qs('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  lockPage(true);
}

function closeCart() {
  const drawer = qs('[data-cart-drawer]');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  lockPage(false);
}

qsa('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

async function refreshCartDrawer() {
  const response = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
  const sections = await response.json();
  const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
  const current = qs('[data-cart-drawer]');
  const replacement = qs('[data-cart-drawer]', parsed);
  if (current && replacement) current.replaceWith(replacement);
  const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((item) => item.json());
  qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
  qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  bindCartLines();
}

async function addToCart(form) {
  const formData = new FormData(form);
  await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
  await refreshCartDrawer();
  
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.quick-add, [data-product-form]');
  if (!form) return;
  event.preventDefault();
  const submit = qs('[type="submit"]', form);
  if (submit) submit.disabled = true;
  try { await addToCart(form); } finally { if (submit) submit.disabled = false; }
});

function bindCartLines() {
  qsa('[data-cart-quantity]').forEach((button) => button.addEventListener('click', async () => {
    const line = Number(button.closest('[data-line]').dataset.line);
    const quantity = Number(button.dataset.cartQuantity);
    await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    await refreshCartDrawer();
    openCart();
  }));
}
bindCartLines();

function formatCartMoney(cents, currency) {
  try {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2).replace('.', ',')} TL`;
  }
}

qsa('[data-whatsapp-cart]').forEach((button) => button.addEventListener('click', async (event) => {
  event.preventDefault();
  const fallbackUrl = button.href;
  const whatsappWindow = window.open('', '_blank');

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Sepet okunamadı');
    const cart = await response.json();
    const lines = [button.dataset.whatsappMessage || 'Merhaba, ürünleriniz hakkında bilgi almak istiyorum.'];

    if (cart.items.length) {
      lines.push('', 'Sepetimdeki ürünler:');
      cart.items.forEach((item, index) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` (${item.variant_title})` : '';
        lines.push(`${index + 1}. ${item.product_title}${variant} — ${item.quantity} adet — ${formatCartMoney(item.final_line_price, cart.currency)}`);
      });
      lines.push('', `Ara toplam: ${formatCartMoney(cart.total_price, cart.currency)}`, `Sepet bağlantısı: ${window.location.origin}${window.Shopify.routes.root}cart`);
    }

    const whatsappUrl = `https://wa.me/${button.dataset.whatsappPhone}?text=${encodeURIComponent(lines.join('\n'))}`;
    if (whatsappWindow) whatsappWindow.location.href = whatsappUrl;
    else window.location.href = whatsappUrl;
  } catch {
    if (whatsappWindow) whatsappWindow.location.href = fallbackUrl;
    else window.location.href = fallbackUrl;
  }
}));

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = qs('input[type="search"]', this);
    this.results = qs('[data-predictive-search]', this);
    let timer;
    this.input?.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.search(), 250);
    });
    document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.close(); });
  }
  async search() {
    const term = this.input.value.trim();
    if (term.length < 2) return this.close();
    const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`;
    const html = await fetch(url).then((response) => response.text());
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    this.results.innerHTML = qs('#shopify-section-predictive-search', parsed)?.innerHTML || '';
    this.results.classList.add('is-open');
    this.input.setAttribute('aria-expanded', 'true');
  }
  close() {
    this.results?.classList.remove('is-open');
    this.input?.setAttribute('aria-expanded', 'false');
  }
}
customElements.define('predictive-search', PredictiveSearch);

qsa('[data-favorite-handle]').forEach((button) => {
  const key = 'st-favorites';
  const read = () => JSON.parse(localStorage.getItem(key) || '[]');
  button.classList.toggle('is-active', read().includes(button.dataset.favoriteHandle));
  button.addEventListener('click', () => {
    const values = read();
    const handle = button.dataset.favoriteHandle;
    const next = values.includes(handle) ? values.filter((item) => item !== handle) : [...values, handle];
    localStorage.setItem(key, JSON.stringify(next));
    button.classList.toggle('is-active', next.includes(handle));
  });
});

qsa('[data-filter-open]').forEach((button) => button.addEventListener('click', () => { qs('[data-filters]')?.classList.add('is-open'); lockPage(true); }));
qsa('[data-filter-close]').forEach((button) => button.addEventListener('click', () => { qs('[data-filters]')?.classList.remove('is-open'); lockPage(false); }));
qs('[data-sort-by]')?.addEventListener('change', (event) => { const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); location.href = url.toString(); });

qsa('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => { const input = qs('input[type="number"]', button.parentElement); input.value = Math.max(1, Number(input.value) - 1); }));
qsa('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => { const input = qs('input[type="number"]', button.parentElement); input.value = Number(input.value) + 1; }));
qs('[data-sticky-submit]')?.addEventListener('click', () => qs('[data-product-form] [type="submit"]')?.click());

const productForm = qs('[data-product-form]');
if (productForm) {
  qsa('input[name^="options"]', productForm).forEach((input) => input.addEventListener('change', () => {
    const selectedOptions = qsa('input[name^="options"]:checked', productForm).map((item) => item.value);
    const select = qs('[data-variant-select]', productForm);
    const variant = qsa('option', select).find((option) => {
      try { return JSON.stringify(JSON.parse(option.dataset.options)) === JSON.stringify(selectedOptions); } catch { return false; }
    });
    const submit = qs('.product-submit', productForm);
    if (variant) {
      select.value = variant.value;
      submit.disabled = variant.disabled;
      submit.textContent = variant.disabled ? 'Tükendi' : 'Sepete ekle';
      const current = qs('.price__current', qs('[data-product-price]'));
      if (current) current.textContent = variant.dataset.price;
      const sticky = qs('[data-sticky-price]');
      if (sticky) sticky.textContent = variant.dataset.price;
      history.replaceState({}, '', `${location.pathname}?variant=${variant.value}`);
    }
  }));
}

qsa('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
  qsa('[data-media-target]').forEach((item) => item.classList.toggle('is-active', item === button));
  qsa('[data-media-id]').forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== button.dataset.mediaTarget));
}));
qsa('[data-lightbox-open]').forEach((button) => button.addEventListener('click', () => {
  const dialog = qs('[data-lightbox]');
  const image = qs('img', button)?.cloneNode();
  const content = qs('[data-lightbox-content]', dialog);
  if (image && dialog && content) { content.replaceChildren(image); dialog.showModal(); }
}));
qs('[data-lightbox-close]')?.addEventListener('click', () => qs('[data-lightbox]')?.close());

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const observer = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      const html = await fetch(this.dataset.url).then((response) => response.text());
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = qs('product-recommendations', parsed);
      if (replacement?.innerHTML.trim()) this.innerHTML = replacement.innerHTML;
    }, { rootMargin: '0px 0px 300px 0px' });
    observer.observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);
